import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import animStyles from '../../styles/animations.module.css';

/**
 * ScrollAnimatedSection - Wrapper component que aplica animaciones de scroll
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenido a animar
 * @param {string} props.animationType - Tipo de animación: 'fadeIn', 'scaleIn', 'slideLeft', 'slideRight'
 * @param {number} props.threshold - Threshold para Intersection Observer (default: 0.2)
 * @param {string} props.className - Clases CSS adicionales
 */
function ScrollAnimatedSection({ 
  children, 
  animationType = 'fadeIn', 
  threshold = 0.2,
  className = '',
  ...props 
}) {
  const { ref, isVisible } = useScrollAnimation({ threshold });

  const animationClass = {
    fadeIn: animStyles.scrollFadeIn,
    scaleIn: animStyles.scrollScaleIn,
    slideLeft: animStyles.scrollSlideLeft,
    slideRight: animStyles.scrollSlideRight
  }[animationType] || animStyles.scrollFadeIn;

  const combinedClassName = `
    ${animStyles.scrollAnimated}
    ${animationClass}
    ${isVisible ? animStyles.visible : ''}
    ${className}
  `.trim();

  return (
    <div ref={ref} className={combinedClassName} {...props}>
      {children}
    </div>
  );
}

export default ScrollAnimatedSection;
